import React, { memo, useCallback, useEffect } from 'react';

import { Text, View, Image, Pressable, StyleSheet } from 'react-native';
import { COLOR, FONT, THEME } from '../../constants/styles';
import { I18n } from '../components';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { sendInvitations, resetState } from './actions';

const InvitePatient = memo((props) => {
  useEffect(() => {
    return () => {
      props.actions.resetState();
    };
  }, []);

  useEffect(() => {
    props.onStatus(props.status);
  }, [props.status]);
  useEffect(() => {
    props.onError(props.errorMessage?.message);
  }, [props.errorMessage]);
  useEffect(() => {
    props.onSuccess(props.sendSuccessMessage ? I18n.aec('invite.patientInviteSuccess') : null);
  }, [props.sendSuccessMessage]);

  const sendPatientInvite = useCallback(() => {
    const email = props.editingCasePatient.email;
    const submitArray = [{ inviteeEmail: email, inviteePhone: null }];
    const message = '';
    const username = props.editingCase.patientName;

    props.actions.sendInvitations(props.editingCase.caseId, submitArray, message, {
      username,
      email,
    });
  }, [props.editingCasePatient, props.editingCase]);

  const shouldEnableThisFeature = () => {
    if (!props.canEditInvites) return false;
    if (!props.editingCaseEmployer?.uiConfig?.features?.sendInvitesToPatients) return false;

    const patientUserId = props.editingCasePatient?.userId;
    return (
      !patientUserId ||
      !Object.keys(props.editingCase?.participants || {}).find((pId) => pId == patientUserId)
    );
  };
  if (!shouldEnableThisFeature()) return null;

  return (
    <Pressable style={styles.resendInviteButton} onPress={sendPatientInvite}>
      <Text style={styles.resendDescriptionText}>
        {I18n.aec('case.invitePatientToJoinTheirCase')}
      </Text>
      <View style={THEME.basicRow}>
        <Text style={styles.resendInviteText}>{I18n.ce_aec('case.sendPatientInvite')}</Text>
        <Image
          style={styles.repeatIcon}
          source={require('../../../resources/icon-add-user.png')}
          resizeMode="contain"
        />
      </View>
    </Pressable>
  );
});
InvitePatient.displayName = 'InvitePatient';

const styles = StyleSheet.create({
  resendInviteButton: {
    paddingHorizontal: 25,
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderColor: COLOR.accent,
  },
  resendInviteText: {
    ...FONT.semibold,
    fontSize: 16,
    color: COLOR.callToAction,
    marginTop: 7,
  },
  resendDescriptionText: {
    ...FONT.regular,
    fontSize: 16,
    color: COLOR.text,
  },
  repeatIcon: {
    width: 18,
    height: 18,
    marginTop: 5,
    marginLeft: 5,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    status: state.screens.invites.status,
    errorMessage: state.screens.invites.errorMessage,
    sendSuccessMessage: state.screens.invites.sendSuccessMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ sendInvitations, resetState }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InvitePatient);
